export default __webpack_public_path__ + "static/media/globaltech.68264731.png";